import { render, staticRenderFns } from "./BankInstructionCreateEdit.vue?vue&type=template&id=b946a296&scoped=true&"
import script from "./BankInstructionCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BankInstructionCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./BankInstructionCreateEdit.vue?vue&type=style&index=0&id=b946a296&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946a296",
  null
  
)

export default component.exports